export default __webpack_public_path__ + "static/media/temioluwa.150fb3e6.png";